<template>
	<section class="w-full max-w-5xl mx-auto">
		<div class="relative w-full flex flex-col bg-white">
      <vue-loading :loading="loading" />
			<div class="flex flex-col">
        <div class="flex">
          <div class="w-full flex my-2 h-8">
            <span class="flex-1 self-center border-t border-gray-300"></span>
            <span class="text-xl font-semibold text-blue-900 text-center px-3">
              {{ locale.Contacts }}
            </span>
            <span class="flex-1 self-center border-t border-gray-300"></span>
          </div>
        </div>
        <div class="mt-6 flex flex-col md:flex-row mb-10 px-3 md:px-0" style="height: 340px">
          <div class="md:w-1/2 md:pr-10">
            <iframe class="w-full h-full" src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d2991.761070435232!2d15.534265!3d41.422705!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x1339d96ff32dbfab%3A0x572117a2246558db!2sAlidaunia%20Servizio%20Elicotteri%2C%20S.S.673%20Km.19%2C00%2C%2071122%20Foggia%20FG!3m2!1d41.422705!2d15.534265!5e0!3m2!1sit!2sit!4v1583402131166!5m2!1sit!2sit" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
          </div>
          <div class="md:w-1/2 flex flex-col">
            <div class="text-blue-800 font-semibold mb-1 text-xl">
              {{ locale.MainBase }}
            </div>
            <p class="leading-normal">
              S.S. 673 km. 19,00<br>
              71122 - Foggia<br>
              Italy<br>
              <p class="mt-3 leading-tight border-t pt-2">
                <i class="text-gray-700">{{ locale.callCenter }}</i><br>
                +39.0881.617961 <span style="font-size:10px">({{ locale.callCenterInfo }})</span>
              </p>
              <p class="mt-2 leading-tight">
                <i class="text-gray-700">fax</i><br>
                +39.0881.619660
              </p>
              <p class="mt-2 leading-tight">
                <i class="text-gray-700">{{ locale.bookings }}</i><br>
                +39.0881.619696
              </p>
              <p class="mt-2 leading-tight">
                <i class="text-gray-700">email (solo per assistenza voli)</i><br>
                assistenza.voli@alidaunia.it
              </p>
              <p class="mt-2 leading-tight">
                <i class="text-gray-700">email (contatto con azienda)</i><br>
                info@alidaunia.it
              </p>
              <p class="mt-2 leading-tight">
                <i class="text-gray-700">pec</i><br>
                alidauniagroup@legalmail.it
              </p>
            </p>
          </div>
        </div>
        <div class="flex justify-center mb-10 border-t pt-3">
          <div class="w-1/2 flex flex-col">
            <div class="flex my-3 flex justify-center">
              <div class="font-semibold text-blue-700 text-xl">{{ locale.MailUs }}</div>
            </div>
            <div class="flex flex-wrap -mx-3">
              <div class="w-full md:w-1/2 px-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  {{ locale.Firstname }}
                </label>
                <input v-model="form.firstname" class="appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white" type="text" :placeholder="locale.Firstname">
              </div>
              <div class="w-full md:w-1/2 px-3 mt-3 md:mt-0">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  {{ locale.Lastname }}
                </label>
                <input v-model="form.lastname" class="appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" type="text" :placeholder="locale.Lastname">
              </div>
            </div>
            <div class="flex flex-wrap -mx-3">
              <div class="w-full md:w-1/2 px-3 mt-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  Email
                </label>
                <input v-model="form.email" class="appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" type="text" placeholder="Email">
              </div>
              <div class="w-full md:w-1/2 px-3 mt-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  {{ locale.Telephone }}
                </label>
                <input v-model="form.telephone" class="appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" type="text" :placeholder="locale.Telephone">
              </div>
            </div>
            <div class="flex flex-wrap -mx-3">
              <div class="w-full md:w-1/2 px-3 mt-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  <span v-if="lang == 'it'">
                    Tipo richiesta
                  </span>
                  <span v-if="lang == 'en'">
                    Request type
                  </span>
                </label>
                <select v-model="form.request_type" class="_appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                  <option></option>
                  <option value="voli" v-text="lang == 'it' ? 'Assistenza sui voli' : 'Flights assistance'" />
                  <option value="contatto" v-text="lang == 'it' ? 'Contatto con l\'azienda' : 'Contact with the company'" />
                </select>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-2">
              <div class="w-full px-3 mt-3">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">
                  {{ locale.Message }}
                </label>
                <textarea v-model="form.message" class="appearance-none block w-full border border-gray-bg-blue-100 text-gray-700 rounded py-2 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" rows="10" :placeholder="locale.Message" />
              </div>
            </div>
            <div class="flex items-center justify-between">
              <div>
                <svg viewBox="0 0 150 150" width="60" height="60">
                  <path d="m117 62.063c-2e-3 -0.60232-0.0159-1.2014-0.0429-1.7976v-33.991l-9.3971 9.3971c-7.691-9.4141-19.391-15.427-32.496-15.427-13.638 0-25.754 6.5097-33.413 16.591l15.403 15.565c1.5095-2.7917 3.6539-5.1895 6.2395-7.0005 2.6891-2.0985 6.4993-3.8143 11.77-3.8143 0.63674 0 1.1282 0.0744 1.4893 0.21458 6.5304 0.51543 12.191 4.1194 15.524 9.3503l-10.903 10.903c13.81-0.0542 29.411-0.086 35.825 7e-3" style="fill:#1c3aa9"/><path d="m74.819 20.246c-0.60232 2e-3 -1.2014 0.0159-1.7976 0.0429h-33.991l9.3971 9.3971c-9.4141 7.691-15.427 19.391-15.427 32.496 0 13.638 6.5098 25.754 16.591 33.413l15.565-15.403c-2.7917-1.5095-5.1895-3.6539-7.0005-6.2395-2.0984-2.6891-3.8143-6.4993-3.8143-11.77 0-0.63674 0.0744-1.1282 0.21458-1.4893 0.51543-6.5304 4.1194-12.191 9.3503-15.524l10.903 10.903c-0.0542-13.81-0.0861-29.411 7e-3 -35.825" style="fill:#4285f4"/><path d="m33.002 62.181c2e-3 0.60232 0.0159 1.2014 0.0429 1.7976v33.991l9.3971-9.3971c7.691 9.4141 19.391 15.427 32.496 15.427 13.638 0 25.754-6.5097 33.413-16.591l-15.403-15.565c-1.5095 2.7917-3.6539 5.1895-6.2395 7.0005-2.6891 2.0985-6.4993 3.8143-11.77 3.8143-0.63674 0-1.1282-0.0744-1.4893-0.21458-6.5304-0.51543-12.191-4.1194-15.524-9.3503l10.903-10.903c-13.81 0.0542-29.411 0.086-35.825-7e-3" style="fill:#ababab"/><path d="m40.078 120.24c-1.0215 0-1.9373 0.19374-2.7475 0.58118-0.81015 0.37866-1.497 0.92024-2.0606 1.6247-0.55478 0.70447-0.98186 1.5587-1.2813 2.5625-0.2906 0.99506-0.4359 2.109-0.4359 3.3418v3.5532c0 1.2416 0.1453 2.36 0.4359 3.3551 0.2994 0.99507 0.72209 1.8448 1.2681 2.5493s1.2064 1.246 1.9813 1.6247 1.6467 0.56799 2.6154 0.56799c0.99507 0 1.8669-0.1453 2.6154-0.4359 0.75731-0.29059 1.3913-0.70888 1.9021-1.2548 0.51074-0.55478 0.90261-1.224 1.1756-2.0078 0.28179-0.78373 0.44911-1.6731 0.50194-2.6682h-2.4437c-0.06165 0.76612-0.16731 1.4222-0.31702 1.9681-0.1497 0.53717-0.36985 0.98187-0.66045 1.3341-0.28179 0.34344-0.65164 0.59881-1.1096 0.76613-0.4491 0.1585-1.0039 0.23775-1.6643 0.23775-0.70448 0-1.3033-0.1541-1.7964-0.46231-0.49313-0.31701-0.8938-0.74851-1.202-1.2945-0.2994-0.54598-0.51955-1.1844-0.66045-1.9153-0.13209-0.73091-0.19813-1.519-0.19813-2.3644v-3.5796c0-0.90699 0.07925-1.7304 0.23776-2.4701 0.16731-0.73969 0.41828-1.3693 0.75291-1.8889 0.33463-0.51956 0.75731-0.92023 1.2681-1.202 0.51074-0.29059 1.1184-0.43589 1.8228-0.43589 0.59 0 1.0963 0.088 1.519 0.26419 0.42269 0.16731 0.77492 0.43149 1.0567 0.79252 0.28179 0.35224 0.49754 0.80134 0.64724 1.3473 0.1497 0.54598 0.25097 1.1976 0.3038 1.9549h2.4437c-0.04402-1.0391-0.20694-1.9593-0.48873-2.7607-0.28179-0.80135-0.67366-1.475-1.1756-2.021-0.50194-0.54596-1.114-0.95985-1.836-1.2416-0.71328-0.2818-1.5366-0.42269-2.4701-0.42269zm59.652 0c-1.0215 0-1.9373 0.19374-2.7475 0.58118-0.81015 0.37866-1.497 0.92024-2.0606 1.6247-0.55477 0.70447-0.98187 1.5587-1.2813 2.5625-0.29059 0.99506-0.43588 2.109-0.43588 3.3418v3.5532c0 1.2416 0.14529 2.36 0.43588 3.3551 0.2994 0.99507 0.7221 1.8448 1.2681 2.5493 0.54598 0.70448 1.2064 1.246 1.9813 1.6247 0.77492 0.37866 1.6467 0.56799 2.6154 0.56799 0.99506 0 1.8668-0.1453 2.6154-0.4359 0.7573-0.29059 1.3913-0.70888 1.9021-1.2548 0.51075-0.55478 0.90261-1.224 1.1756-2.0078 0.2818-0.78373 0.44912-1.6731 0.50194-2.6682h-2.4436c-0.0616 0.76612-0.16731 1.4222-0.31702 1.9681-0.1497 0.53717-0.36985 0.98187-0.66044 1.3341-0.28179 0.34344-0.65164 0.59881-1.1096 0.76613-0.4491 0.1585-1.0039 0.23775-1.6643 0.23775-0.70448 0-1.3033-0.1541-1.7964-0.46231-0.49313-0.31701-0.89381-0.74851-1.202-1.2945-0.2994-0.54598-0.51955-1.1844-0.66045-1.9153-0.13208-0.73091-0.19813-1.519-0.19813-2.3644v-3.5796c0-0.90699 0.0793-1.7304 0.23776-2.4701 0.16732-0.73969 0.41828-1.3693 0.75292-1.8889 0.33462-0.51956 0.75731-0.92023 1.268-1.202 0.51075-0.29059 1.1184-0.43589 1.8228-0.43589 0.58999 0 1.0963 0.088 1.519 0.26419 0.42269 0.16731 0.77493 0.43149 1.0567 0.79252 0.28178 0.35224 0.49753 0.80134 0.64723 1.3473 0.1497 0.54598 0.25097 1.1976 0.30381 1.9549h2.4436c-0.0441-1.0391-0.20693-1.9593-0.48873-2.7607-0.28179-0.80135-0.67365-1.475-1.1756-2.021s-1.114-0.95985-1.836-1.2416c-0.71327-0.2818-1.5366-0.42269-2.4701-0.42269zm-45.729 0.26418-6.195 19.232h2.4833l1.4926-5.0194h6.4988l1.519 5.0194h2.4833l-6.2082-19.232zm10.897 0v19.232h2.4172v-7.5291h3.7117c0.92463 0 1.7436-0.12769 2.4569-0.38306 0.71328-0.26418 1.3121-0.64283 1.7964-1.136 0.49313-0.49314 0.86298-1.1007 1.1095-1.8228 0.25537-0.7309 0.38306-1.5586 0.38306-2.4833 0-0.85418-0.12768-1.6379-0.38306-2.3512-0.24657-0.7221-0.61202-1.3429-1.0963-1.8625-0.48433-0.52835-1.0875-0.93783-1.8096-1.2284-0.71328-0.29059-1.5322-0.43589-2.4569-0.43589zm13.724 0v2.087h5.0458v17.145h2.4172v-17.145h5.059v-2.087zm30.341 0v19.232h2.4172v-8.8896h7.7404v8.8896h2.4304v-19.232h-2.4304v8.2688h-7.7404v-8.2688zm21.755 0-6.195 19.232h2.4833l1.4926-5.0194h6.4988l1.519 5.0194h2.4833l-6.2082-19.232zm-63.403 2.087h3.7117c0.59 0 1.0919 0.1056 1.5058 0.31701 0.42268 0.21133 0.76612 0.49312 1.0303 0.84536 0.27298 0.35224 0.47112 0.76171 0.5944 1.2284 0.13209 0.4579 0.19814 0.93343 0.19814 1.4266 0 0.54597-0.06604 1.0479-0.19814 1.5058-0.12328 0.44911-0.32142 0.84098-0.5944 1.1756-0.26418 0.32582-0.60761 0.58119-1.0303 0.76612-0.41388 0.18492-0.91582 0.27738-1.5058 0.27738h-3.7117zm-12.284 1.2945 2.6286 8.7443h-5.2439zm76.717 0 2.6286 8.7443h-5.2439zm-113.78 1.2945c-0.60761 0-1.1316 0.1541-1.5719 0.46231-0.43149 0.30821-0.79254 0.72649-1.0831 1.2548l-0.03963-1.453h-2.2719v14.292h2.338v-10.224c0.22015-0.60762 0.53276-1.0875 0.93783-1.4398 0.41388-0.35223 0.93784-0.52835 1.5719-0.52835 0.20254 0 0.38306 9e-3 0.54156 0.0264 0.15851 9e-3 0.33022 0.0308 0.51515 0.066l-0.01321-2.2719c-0.03523-0.0177-0.09246-0.0353-0.17172-0.0529-0.07044-0.0265-0.1497-0.0485-0.23776-0.066-0.08807-0.0176-0.18052-0.0309-0.27739-0.0397-0.08807-0.0176-0.16731-0.0264-0.23776-0.0264zm7.8593 0c-0.67806 0-1.3341 0.11887-1.9681 0.35664-0.63403 0.23776-1.1976 0.62962-1.6907 1.1756-0.48432 0.53716-0.87619 1.2416-1.1756 2.1134-0.2994 0.86298-0.4491 1.9241-0.4491 3.1834v1.6115c0 1.0919 0.12769 2.0386 0.38306 2.8399s0.62082 1.4662 1.0963 1.9946c0.48433 0.51954 1.0699 0.907 1.7568 1.1624 0.68686 0.25538 1.4574 0.38306 2.3116 0.38306 0.61642 0 1.1668-0.0617 1.6511-0.18492 0.49313-0.12329 0.92903-0.2818 1.3077-0.47553 0.37866-0.20255 0.70448-0.43149 0.97746-0.68686s0.50634-0.51955 0.70007-0.79254l-1.2152-1.4794c-0.19373 0.23775-0.40067 0.45791-0.62082 0.66045-0.22015 0.19372-0.46231 0.36545-0.72649 0.51514-0.26418 0.1409-0.55478 0.25098-0.87179 0.33023-0.31701 0.0792-0.67366 0.11888-1.0699 0.11888-1.0831 0-1.9153-0.34784-2.4965-1.0435-0.57239-0.69567-0.85858-1.8096-0.85858-3.3419v-0.33023h7.9782v-1.3605c0-1.0919-0.09246-2.0562-0.27739-2.8928-0.18492-0.83657-0.47992-1.541-0.885-2.1134-0.40507-0.57239-0.92463-1.0039-1.5587-1.2945-0.63403-0.29941-1.4001-0.4491-2.2984-0.4491zm0 2.0078c0.51074 0 0.93343 0.0924 1.2681 0.27739 0.33462 0.18492 0.5988 0.44469 0.79254 0.77931 0.20254 0.33463 0.34783 0.73532 0.43589 1.202 0.09686 0.4579 0.1585 0.96424 0.18492 1.519v0.31701h-5.627c0.03523-0.80135 0.13209-1.4662 0.2906-1.9946s0.36545-0.94665 0.62082-1.2548c0.26418-0.31701 0.56798-0.53715 0.91142-0.66044 0.34343-0.12328 0.71768-0.18492 1.1228-0.18492z" style="fill:#a6a6a6"/>
                </svg>
              </div>
              <button @click="validate" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button">
                <i class="fa fa-envelope mr-1" />
                {{ locale.Send }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Locales from '../../locales.json'

export default {
  name: 'Contacts',
  data:() => ({
    loading: false,
    form: {
      firstname: null,
      lastname: null,
      email: null,
      telephone: null,
      request_type: null,
      message: null
    },
    locales: null
  }),
  computed: {
    lang() {
      return this.$parent.lang
    },
		locale() {
			return this.locales[this.lang]
		}
  },
  methods: {
    validate() {
      let { form: { firstname, lastname, email, telephone, request_type, message }, locale } = this

      function validateEmail(email) {
				var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return re.test(String(email).toLowerCase());
			}

      if (! firstname || ! lastname || ! email || ! telephone || ! request_type || ! message) {
        notifyW(locale.AllFieldsMandatory)
        return
      }

      if (! validateEmail(email)) {
        notifyW(locale.EmailInvalid)
        return
      }

      this.recaptcha()
    },
    async recaptcha() {
      this.loading = true
      try {
        await this.$recaptchaLoaded()

        const token = await this.$recaptcha('login')

        dbg(token, 'reCAPTCHA_TOKEN')

        this.submit()
      }
      catch (error) {
        this.loading = false
        notifyE('reCaptcha error...')
        callErrors(error)
      }
    },
    async submit() {
      try {

        let { lang, form } = this
        let { data } = await api.post('api.contact-requests.store', { lang, form })
        let { status, message } = data
        if (status == 'success') {
          notifyS(message)
          this.form = {
            firstname: null,
            lastname: null,
            email: null,
            telephone: null,
            request_type: null,
            message: null
          }
        }
        if (status == 'error') {
          notifyE(message)
        }
        this.loading = false
      }
      catch(error) {
        callErrors(error)
        this.loading = false
      }
    }
  },
  created() {
    this.locales = Locales
  }
}
</script>
